export default __webpack_public_path__ + "static/media/responsive_expert_suppon brt_and_guidance.1fb119cd.webp";